import React, { Component } from "react";
import { observer } from "mobx-react";

import { defined } from "@formant/core/common/defined";
import { IAnnotation } from "@formant/core/model/IAnnotation";
import { IAnnotationField } from "@formant/core/model/IAnnotationField";
import { IAnnotationTemplate } from "@formant/core/model/IAnnotationTemplate";
import { ITaggedUsers } from "@formant/core/model/ITaggedUsers";
import { ITags } from "@formant/core/model/ITags";
import { IValidation } from "@formant/core/model/IValidation";

import { EditSheetChoiceAnnotationField } from "./EditSheetChoiceAnnotationField";
import { EditTagAnnotationField } from "./EditTagAnnotationField";
import { EditUserAnnotationField } from "./EditUserAnnotationField";

export interface IEditAnnotationFieldsProps {
    className?: string;
    annotationTemplate: IAnnotationTemplate;
    annotation: IAnnotation;
    onChange: (annotation: IAnnotation) => void;
    validation: IValidation;
}

@observer
export class EditAnnotationFields extends Component<IEditAnnotationFieldsProps> {
    public render() {
        const { onChangeTags, onChangeTaggedUsers } = this;
        const { className, annotationTemplate, annotation, validation } =
            this.props;
        const { tags, taggedUsers } = annotation;

        return annotationTemplate.fields.map((field, i) => {
            const invalid =
                !!validation[`tags.${field.key}`] ||
                !!validation[`taggedUsers.${field.key}`];
            return (
                (field.type === "tag" && (
                    <EditTagAnnotationField
                        key={i}
                        field={field as IAnnotationField<"tag">}
                        tags={tags || {}}
                        onChange={onChangeTags}
                        className={className}
                        invalid={invalid}
                    />
                )) ||
                (field.type === "sheet" && (
                    <EditSheetChoiceAnnotationField
                        key={i}
                        annotationTemplateId={defined(annotationTemplate.id)}
                        field={field as IAnnotationField<"sheet">}
                        tags={tags || {}}
                        onChange={onChangeTags}
                        className={className}
                        invalid={invalid}
                    />
                )) ||
                (field.type === "user" && (
                    <EditUserAnnotationField
                        key={i}
                        field={field as IAnnotationField<"user">}
                        taggedUsers={taggedUsers || {}}
                        onChange={onChangeTaggedUsers}
                        className={className}
                    />
                ))
            );
        });
    }

    public onChangeTags = (tags: ITags): void => {
        const { onChange, annotation } = this.props;
        onChange({ ...annotation, tags });
    };

    public onChangeTaggedUsers = (taggedUsers: ITaggedUsers): void => {
        const { onChange, annotation } = this.props;
        onChange({ ...annotation, taggedUsers });
    };
}
